<template>
    <div class="sustainability-has">

        <p class="indent">Доклади за устойчиво развитие</p>

      <p  class="indent">
        <a href="/static/files/sustainability/Alcomet_SR-2025.pdf" target="_blank">Доклад за устойчиво развитие 2025</a>
      </p>
      <p  class="indent">
        <a href="/static/files/sustainability/Alcomet_SR-2024.pdf" target="_blank">Доклад за устойчиво развитие 2024</a>
      </p>

      <p  class="indent">
        <a href="/static/files/sustainability/Alcomet-SR-2023-EN01-0724-Preview-240806.pdf" target="_blank">Доклад за устойчиво развитие 2023</a>
      </p>

      <p  class="indent">
        <a href="/static/files/sustainability/Alcomet-AD-Sustainability-Report-2022.pdf" target="_blank">Доклад за устойчиво развитие 2021 и 2022</a>
      </p>
        <p  class="indent">
            <a href="/static/files/sustainability/Alcomet-GRI-Report-2020.pdf" target="_blank">Доклад за устойчиво развитие 2020</a>
        </p>
        <p class="indent">
          <a href="/static/files/sustainability/алкомет-доклад-за-усточиво-развитие-2019.pdf" target="_blank">Доклад за устойчиво развитие 2019</a>
        </p>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-has > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-has {
    padding-bottom: 20px;
  }
  .sustainability-has > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/SustainabilityReports.vue